const CALENDAR_SYNCABLE_TYPES = ['meeting', 'call', 'whatsapp', 'email', 'task'] as const;

export type CalendarSyncableType = (typeof CALENDAR_SYNCABLE_TYPES)[number];

export function isCalendarSyncable(type: string | null | undefined): type is CalendarSyncableType {
  if (!type) return false;
  return (CALENDAR_SYNCABLE_TYPES as readonly string[]).includes(type);
}

function isMeetingType(type: string | null | undefined): boolean {
  return type === 'meeting';
}
